import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Blog() {
  const blogs = [
    {
      title: "How to Grow Your Junk Removal Business in 2026 (1)",
      description:
        "Discover proven junk removal marketing tips, SEO strategies, and modern tools to increase junk removal sales fast.",
      link: "/how-to-grow-your-junk-removal-business-2026-1",
      image:
        "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/How%20to%20Grow%20Your%20Junk%20Removal%20Business%20Pro%20Tips%20in%202026.png",
      isReal: true,
    },
    {
      title: "How to Grow Your Junk Removal Business in 2026 (2)",
      description:
        "Advanced strategies including referrals, automation, upselling, and customer retention techniques.",
      link: "/how-to-grow-your-junk-removal-business-2026-2",
      image:
        "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/How%20to%20Grow%20Your%20Junk%20Removal%20Business%20Pro%20Tips%20in%202026-2.png",
      isReal: true,
    },
    {
      title: "How to Grow Your Junk Removal Business in 2026 (3)",
      description:
        "Final growth strategies covering partnerships, branding, analytics, and long-term scaling.",
      link: "/how-to-grow-your-junk-removal-business-2026-3",
      image:
        "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/How%20to%20Grow%20Your%20Junk%20Removal%20Business%20Pro%20Tips%20in%202026-3.jpg",
      isReal: true,
    },
  ];

  return (
    <div style={{ fontFamily: "Arial, sans-serif", background: "#fff" }}>
      <Helmet>
        <title>Blog | Reflex Advisor</title>
        <meta
          name="description"
          content="Read the latest business growth and automation strategies from Reflex Advisor."
        />
        <link rel="canonical" href="https://www.reflexadvisor.com/blog" />
      </Helmet>

      {/* HEADER */}
      <div
        style={{
          textAlign: "center",
          padding: "90px 20px",
          borderBottom: "1px solid #eee",
        }}
      >
        <h1 style={{ fontSize: "52px", fontWeight: "800" }}>
          Our Blog
        </h1>
      </div>

      {/* BLOG GRID */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "40px 20px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "25px",
          }}
        >
          {blogs.map((blog, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #eee",
                borderRadius: "12px",
                overflow: "hidden",
                background: "#fff",
                transition: "0.3s",
              }}
            >
              {/* IMAGE */}
              <img
                src={blog.image}
                alt={blog.title}
                style={{
                  width: "100%",
                  height: "180px",
                  objectFit: "cover",
                }}
              />

              {/* CONTENT */}
              <div style={{ padding: "18px" }}>
                <h2
                  style={{
                    fontSize: "18px",
                    marginBottom: "10px",
                    lineHeight: "1.4",
                  }}
                >
                  {blog.title}
                </h2>

                <p
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    marginBottom: "15px",
                  }}
                >
                  {blog.description}
                </p>

                <Link
                  to={blog.link}
                  style={{
                    textDecoration: "none",
                    color: "#fff",
                    background: "#7c3aed",
                    padding: "10px 18px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    display: "inline-block",
                    fontWeight: "600",
                  }}
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}